import { AppManager } from './AppManager.esm.js';

function createSpecializedApp(options) {
  return new AppManager(options);
}

export { createSpecializedApp };
//# sourceMappingURL=createSpecializedApp.esm.js.map
